import { Card, CardContent, Typography } from '@material-ui/core';
import ControlPointDuplicateIcon from '@material-ui/icons/ControlPointDuplicate';
import DevicesIcon from '@material-ui/icons/Devices';
import DnsIcon from '@material-ui/icons/Dns';
import ExploreIcon from '@material-ui/icons/Explore';
import WifiIcon from '@material-ui/icons/Wifi';
import WifiOffIcon from '@material-ui/icons/WifiOff';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import {
  browserName, deviceType, isMobile, mobileModel, mobileVendor, osName
} from 'react-device-detect';
import { useTranslation } from 'react-i18next';

function Connections({ className, ...rest }) {
  const { t } = useTranslation('profile');

  const publicIp = require('public-ip');
  const [IpAdres, SetIpAdres] = useState();

  const renderContent = () => {
    if (isMobile) {
      return `${mobileModel} ${deviceType} ${mobileVendor} ${osName}`;
    }
    return t('Mobile_Cihaz_degil');
  };
  const { detect } = require('detect-browser');
  const browser = detect();

  (async () => {
    SetIpAdres(await publicIp.v4());
    // SetMacAdres(await publicIp.v6());
  })();


  return (
    <Card>
      <CardContent>
        <Typography variant="h5" gutterBottom>
          {t('Baglanti_Durumu')}
        </Typography>
        <Typography variant="subtitle1" gutterBottom>
          {
            window.navigator.onLine
              ? (
                <div>
                  <WifiIcon color="primary" />
                  {' '}
                  {t('Bagli')}
                </div>
              )
              : (
                <div>
                  <WifiOffIcon color="error" />
                  {' '}
                  {t('Bagli_degil')}
                </div>
              )
}


        </Typography>
        <Typography variant="h5" gutterBottom>
          IP
          {' '}
          {t('Adres')}
        </Typography>
        <Typography variant="subtitle1" gutterBottom>
          <DnsIcon color="error" />
          {t('IpAdres')}
        </Typography>
        <Typography variant="h5" gutterBottom>
          {t('Tarayici')}
        </Typography>
        <Typography variant="subtitle1" gutterBottom>
          <ExploreIcon color="primary" />
          {' '}
          {browserName}
          {' '}
          {browser.version}
          {' '}
          {browser.os}
        </Typography>
        <Typography variant="h5" gutterBottom>
          {t('Cihaz')}
        </Typography>
        <Typography variant="subtitle1" gutterBottom>
          <DevicesIcon color="primary" />
          {' '}
          {renderContent()}
        </Typography>
        <Typography variant="h5" gutterBottom>
          {t('Version')}
        </Typography>
        <Typography variant="subtitle1" gutterBottom>
          <ControlPointDuplicateIcon color="primary" />
          v
          {process.env.REACT_APP_VERSION}
        </Typography>
      </CardContent>
    </Card>
  );
}
Connections.propTypes = {
  className: PropTypes.string
};

export default Connections;
